import "bootstrap/dist/css/bootstrap.css";
import React, { Component } from "react";
import { Nav, Footer } from "./controls/Layout";
import { Main } from "./controls/Main";

import "./App.css";

class App extends Component {
  render() {
    return (
      <div id="app">
        <Nav />
        <Main />
        <Footer />
      </div>
    );
  }
}

export default App;
